<template>
  <div>
    <v-text-field
      ref="input"
      v-model="value"
      :error-messages="errors"
      append-icon="mdi-crosshairs"
      class="cursor-pointer rounded-lg"
      clear-icon="mdi-close-circle-outline"
      clearable
      dense
      hide-details
      label="انتخاب کاربران"
      outlined
      readonly
      @click="dialog = true"
      @click:clear="clearFilter"
    />

    <custom-popup v-model="dialog" :cons="cons" max-width="800px">
      <v-card :loading="loading" class="transparent" flat>
        <v-row no-gutters>
          <v-col class="pa-2" cols="12" md="4" sm="6">
            <v-select
              v-model="tableProps.length"
              :items="[10, 25, 50, 100, 200, 400]"
              dense
              hide-details
              outlined
              @change="reloadTable()"
            />
          </v-col>

          <v-col class="pa-2" cols="12" md="4" sm="6">
            <v-text-field
              v-model="tableProps.search"
              append-icon="mdi-magnify"
              clear-icon="mdi-close-circle-outline"
              clearable
              dense
              hide-details
              label="جستوجو"
              outlined
              @keydown.enter="reloadTable()"
              @click:append="reloadTable()"
              @click:clear="clearFilter"
            />
          </v-col>
           <v-col class="pa-2" cols="12" lg="3" md="3" sm="6">
            <v-text-field
              v-model="tableProps.id"
              append-icon="mdi-magnify"
              clear-icon="mdi-close-circle-outline"
              clearable
              dense
              hide-details
              label="شناسه"
              outlined
              type="number"
              @keydown.enter="reloadTable()"
              @click:append="reloadTable()"
              @click:clear="$nextTick(() => reloadTable())"
            />
          </v-col>
            <v-col class="pa-2" cols="12" lg="3" md="3" sm="6">
          <v-text-field
            v-model="tableProps.name"
            append-icon="mdi-magnify"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            hide-details
            label="نام"
            outlined
            @keydown.enter="reloadTable()"
            @click:append="reloadTable()"
            @click:clear="$nextTick(() => reloadTable())"
          />
        </v-col>

        <v-col class="pa-2" cols="12" lg="3" md="3" sm="6">
          <v-text-field
            v-model="tableProps.lastName"
            append-icon="mdi-magnify"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            hide-details
            label="نام خانوادگی"
            outlined
            @keydown.enter="reloadTable()"
            @click:append="reloadTable()"
            @click:clear="$nextTick(() => reloadTable())"
          />
        </v-col>

          <!--        <v-col class="pa-2" cols="12" md="4" sm="6">-->
          <!--          <v-btn class="btn-add-with-text ma-0" @click="confirm">-->
          <!--            تایید-->
          <!--          </v-btn>-->
          <!--        </v-col>-->

          <v-col class="pa-2" cols="12">
            <data-table
              :columns="columns"
              :data="userInfo"
              :translate="translate"
            >
              <div slot="filters" />

              <div slot="pagination">
                <pagination
                  v-if="userInfo && userInfo.data"
                  ref="pagination"
                  :data="userInfo"
                  @page="onPagination"
                >
                  <template v-slot:per-page>
                    <v-select
                      v-model="tableProps.length"
                      :items="[10, 25, 50, 100, 400]"
                      :menu-props="{ offsetY: true }"
                      class="ma-2 my-md-0"
                      dense
                      label="تعداد نمایش"
                      outlined
                      @change="onPerPage"
                    />
                  </template>
                </pagination>
              </div>
            </data-table>
          </v-col>
        </v-row>
      </v-card>
    </custom-popup>
  </div>
</template>

<script>
import pagination from "@/view/pages/pickers/pagination";
import routePagination from "@/view/content/route-pagination";
import CheckboxFild from "@/view/pages/admin/users/CheckboxFild";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  components: { pagination, routePagination },

  name: "userPicker",

  props: ["value", "errors"],
  data() {
    return {
      selectedRows: [],
      dialog: false,
      cons: {
        title: "انتخاب کاربران",
        buttons: [{ type: "submit", handler: this.confirm }],
      },
      userWallet: [],
      dialogInfo: null,
      loading: false,
      translate: {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      },
      url: "admin/users",
      userInfo: {},
      tableProps: {
        search: "",
        length: 10,
        column: "id",
        dir: "desc",
      },
      columns: [
        {
          label: `<input type="checkbox" id="select_all" onclick="window.Vue.$emit('selectAllListCheckBox', this)"/>`,
          component: CheckboxFild,
          event: "change",
          handler: this.change,
        },
        {
          label: "شناسه",
          name: "id",
          orderable: true,
          colStyle: "width: 100px;",
        },
        {
          label: "نام",
          name: "name",
          orderable: true,
        },
        {
          label: "نام کاربری",
          name: "username",
          orderable: true,
        },
        {
          label: "تلفن",
          name: "phone",
          orderable: true,
        },
        {
          label: "نوع کاربر",
          name: "type",
          orderable: true,
          transform: (value, data) => {
            return value.data.type == "regular" ? "شخص حقیقی" : "شخص حقوقی";
          },
        },
      ],
    };
  },

  created() {
    this.getUserInfo(this.url);
    if (!!this.value?.length) this.selectedRows = this.value;
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t(this.$route.meta.title) },
    ]);

    window.Vue.$on("selectAllListCheckBox", (e) => {
      this.selectAll(e.checked);
    });
  },

  watch: {
    selectedRows() {
      this.$emit("input", this.selectedRows);
    },
    dialog(val) {
      if (!!val) {
        this.getUserInfo(this.url);
      }
    },
  },

  methods: {
    confirm() {
      this.$nextTick(() => {
        this.$emit("confirm");
      });
      this.dialog = false;
    },
    selectAll(c) {
      window.Vue.$emit("selectedAllCheckbox", c);
    },
    change(data, checked) {
      if (checked) {
        this.selectedRows.push(data.id);
      } else {
        let index = this.selectedRows.indexOf(data.id);
        this.selectedRows = [
          ...this.selectedRows.slice(0, index),
          ...this.selectedRows.slice(index + 1, this.selectedRows.length),
        ];
      }
      window.document.querySelector("#select_all").checked =
        this.selectedRows.length == this.userInfo.data.length;
    },
    getUserInfo(url = this.url, params = this.tableProps) {
      this.loading = true;

      this.requestApiGet(url, params)
        .then((response) => {
          this.userInfo = response.data;
        })
        .finally(() => (this.loading = false));
    },
    clearFilter() {
      this.$nextTick(() => {
        this.$emit("input", []);
        this.reloadTable();
        setTimeout(() => {
          this.$emit("confirm");
        }, 100);
      });
    },
    onPagination(e) {
      if (e !== this.page) {
        this.tableProps.page = e;
        this.$nextTick(() => {
          this.getUserInfo();
          window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
        });
      }
    },
    onPerPage() {
      this.$refs.pagination.last_emit = 1;
      window.scrollTo({ behavior: "smooth", top: 0, left: 0 });
    },
    reloadTable(params) {
      this.getUserInfo(this.url, params);
    },
    actions(data, type) {
      this[type](data);
    },
    edit(data) {
      this.$router.push({ name: "admin.user.edit", params: { id: data.id } });
    },
    information(data) {
      this.$router.push({
        name: "admin.users.information",
        params: { id: data.id },
      });
    },
  },
};

$("#select_all").click(function () {
  $(".checkBox").prop("checked", $(this).prop("checked"));
});
</script>

<style scoped></style>
